import { Link } from '@tanstack/react-router';
import styles from './LegalLinks.module.css';

// newTab: beside a form, so reading the policy doesn't discard what was typed.
export function LegalLinks({ newTab = false }: { newTab?: boolean }) {
  const opens = newTab ? { target: '_blank', rel: 'noopener' } : {};
  const hint = newTab && <> <span className="sr-only">(opens in a new tab)</span></>;
  return (
    <nav className={styles.links} aria-label="Legal">
      <Link to="/privacy" className={styles.link} {...opens}>PRIVACY POLICY{hint}</Link>
      <Link to="/terms" className={styles.link} {...opens}>TERMS{hint}</Link>
    </nav>
  );
}
